import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useAuthStore } from './auth.store';
import { authAxios, refreshAccessToken } from './authAxios';
export function useAuth() {
    const { setAuth, clearAuth } = useAuthStore();
    const navigate = useNavigate();
    const { instance } = useMsal();
    const login = async (email, password, rememberMe) => {
        const res = await authAxios.post('user-manager/auth/login', {
            email,
            password,
            remember_me: rememberMe,
        });
        const payload = res.data.messages?.[0];
        if (!payload || res.data.errors?.length > 0) {
            throw new Error(res.data.errors?.[0] ?? 'Login failed.');
        }
        const firstName = payload.user.first_name;
        const lastName = payload.user.last_name;
        const roleName = (payload.user.role_name ?? '');
        const user = {
            id: payload.user.id,
            email: payload.user.email,
            firstName,
            lastName,
            fullName: `${firstName} ${lastName}`.trim(),
            roleId: payload.user.role_id,
            roleName,
            role: roleName,
            permissions: payload.user.permissions ?? [],
            isSuperAdmin: payload.user.is_super_admin ?? false,
            status: payload.user.status,
            regionCode: payload.user.region_code ?? undefined,
            countryId: payload.user.country_id ?? undefined,
        };
        setAuth(payload.access_token, payload.expires_at, user, payload.refresh_token);
    };
    const logout = async () => {
        const { accessToken } = useAuthStore.getState();
        try {
            await authAxios.post('user-manager/auth/logout', {}, { headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {} });
        }
        catch {
            // Proceed with local cleanup regardless of server response.
        }
        finally {
            clearAuth();
            const msalAccount = instance.getActiveAccount();
            if (msalAccount) {
                // SSO login: sign out of Microsoft to clear its token cache.
                // logoutRedirect handles the final navigation — postLogoutRedirectUri
                // brings the user back to /login after Microsoft's logout endpoint runs.
                instance.logoutRedirect({
                    account: msalAccount,
                    postLogoutRedirectUri: '/login',
                });
            }
            else {
                navigate('/login', { replace: true });
            }
        }
    };
    return { login, logout, refreshToken: refreshAccessToken };
}
